import React from 'react';
import classnames from 'classnames';
import { FormikErrors } from 'formik';
import { useTranslation } from 'react-i18next';
import { Form } from 'semantic-ui-react';
import styled from 'styled-components';

import { Dropdown } from '@/components/shared/Dropdown';
import { AdminRole, adminRoles } from '@/types/affiliation';
import { Label } from '@/components/shared/Label';

import * as styles from './Style.module.scss';

export type Values = {
  email: string;
  role: AdminRole;
};

type Props = {
  errors: Partial<Record<keyof Values, string>>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void | FormikErrors<Values>>;
  isLoading: boolean;
  values: Values;
};
export const FormContents: React.FC<Props> = ({
  errors,
  handleChange,
  handleSubmit,
  setFieldValue,
  isLoading,
  values,
}) => {
  const { t } = useTranslation();
  const handleChangeRole = (selectedRole: AdminRole) =>
    setFieldValue('role', selectedRole);
  return (
    <Styled>
      <Form onSubmit={handleSubmit} className="invite-form">
        <Form.Field>
          <Form.Input
            data-test="email"
            className={classnames('field', {
              error: errors.email,
            })}
            fluid={true}
            label={t('models.contact.email')}
            name="email"
            onChange={handleChange}
            value={values.email}
          />
          {errors.email && <Label>{errors.email}</Label>}
        </Form.Field>
        <Form.Field>
          <div className="field">
            <label>{t('models.affiliation.role')}</label>
            <Dropdown
              dataTest="roles"
              text={t(`models.affiliation.roleType.${values.role}.name`)}
              buttonClassNames={styles.toggleButton}
              menuWrapperClassNames={styles.menuWrapper}
              menuNode={adminRoles.map((roleItem) => (
                <div
                  key={roleItem}
                  data-test={`${roleItem}-role`}
                  onClick={() => handleChangeRole(roleItem)}
                  className={classnames(
                    styles.menuItem,
                    values.role === roleItem ? 'active' : '',
                  )}
                >
                  {t(`models.affiliation.roleType.${roleItem}.name`)}

                  <div className={styles.menuItemDescription}>
                    {t(`models.affiliation.roleType.${roleItem}.description`)}
                  </div>
                </div>
              ))}
            />
          </div>
          <div className="button-group">
            <Form.Button
              data-test="do-invite"
              type="submit"
              primary={true}
              disabled={isLoading}
            >
              {t('ui.action.inviteNow')}
            </Form.Button>
          </div>
        </Form.Field>
      </Form>
    </Styled>
  );
};

const Styled = styled.div`
  .invite-form .button-group {
    margin: 3.5em 0 7.5em;
    text-align: center;
  }
`;
